import React from 'react';
import { ReactComponent as Logo } from 'images/vendit_logo.svg';

const VenditLogo: React.FunctionComponent = () => <Logo width={151} height={32.5} />;

export default VenditLogo;
